import * as React from 'react';
import { SVGProps } from 'react';

const BankID = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 27 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.988 16.704h-5.794c-.179 0-.325.127-.325.282v1.347c0 .155.146.28.325.28h5.794c.179 0 .325-.125.325-.28v-1.347c0-.155-.146-.282-.325-.282Zm-17.182 0H2.012c-.179 0-.325.127-.325.282v1.347c0 .155.146.28.325.28h5.794c.179 0 .325-.125.325-.28v-1.347c0-.155-.146-.282-.325-.282Zm8.59-3.818h-5.793c-.178 0-.324.126-.324.282v1.347c0 .154.146.28.324.28h5.794c.179 0 .325-.126.325-.28v-1.347c0-.156-.146-.282-.325-.282Zm-8.59 0H2.012c-.179 0-.325.126-.325.282v1.347c0 .154.146.28.325.28h5.794c.179 0 .325-.126.325-.28v-1.347c0-.156-.146-.282-.325-.282Zm17.182-3.82h-5.794c-.18 0-.325.127-.325.282v1.347c0 .155.146.28.325.28h5.794c.179 0 .325-.125.325-.28V9.348c0-.155-.146-.281-.325-.281Zm-8.591.002h-5.794c-.178 0-.324.126-.324.282v1.346c0 .155.146.281.324.281h5.794c.179 0 .325-.126.325-.28V9.35c0-.156-.146-.282-.325-.282Zm8.59-3.818h-5.793c-.179 0-.325.126-.325.281v1.347c0 .155.146.281.325.281h5.794c.179 0 .325-.126.325-.28V5.53c0-.155-.146-.281-.325-.281Zm-17.181 0H2.012c-.179 0-.325.126-.325.281v1.347c0 .155.146.281.325.281h5.794c.179 0 .325-.126.325-.28V5.53c0-.155-.146-.281-.325-.281Z"
            fill="#fff"
        />
    </svg>
);

export default BankID;
